<template>
  <pt-life-experience-pavilion-reservation-table
    class="pt-hospital-tablee__withData"
    ref="table"
    :tableLabels="tableLabels"
    :tableData="tableData"
    @getTableData="getTableData"
    :totalNumber="totalNumber"
    :isOutside="isOutside"
    :isInvoice="isInvoice"
    :isFinanceAudit="isFinanceAudit"
  >
    <slot />
  </pt-life-experience-pavilion-reservation-table>
</template>

<script>
import PtLifeExperiencePavilionReservationTable from './index'
import { channelFiltterOptions } from 'json/goods-order-options'
import { invoiceStatus } from '../../pt-life-experience-pavilion-invoice/invoice'
import { cashCount } from '@/utils/formUtils'
import { receiveTypeOptions } from '../../pt-life-experience-pavilion-reservation/life-experience-pavilion-reservation'

export default {
  name: 'pt-life-experience-pavilion-reservation-table__withData',
  components: {
    'pt-life-experience-pavilion-reservation-table': PtLifeExperiencePavilionReservationTable
  },
  props: {
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    pageSize: {
      type: Number,
      default: 10
    },
    params: {
      type: Object,
      default: function () {
        return {}
      }
    },
    isFromRouter: Boolean,
    isInvoice: Boolean,
    isFinanceAudit: Boolean
  },
  computed: {
    page () {
      return this.$refs.table.page
    }
  },
  data () {
    return {
      originData: [],
      tableData: [],
      totalNumber: 0,
      isOutside: false
    }
  },
  watch: {
    params: {
      handler: function (val) {
        if (!this.isFromRouter) {
          this.$refs.table.resetPage()
        } else {
          this.isOutside = true
          this.getTableData(this.page)
        }
      },
      deep: true
    }
  },
  methods: {
    resetPage () {
      this.$refs.table.resetPage()
    },
    getTableData (page, next) {
      const { reservationDate, createdDate, time, searchKey, status, reservationInvoiceStatus, channel } = this.params
      const reservationStartTime = reservationDate
        ? reservationDate.reservationStartTime
        : ''
      const reservationEndTime = reservationDate
        ? reservationDate.reservationEndTime
        : ''
      const createdStartTime = createdDate ? createdDate.createdStartTime : ''
      const createdEndTime = createdDate ? createdDate.createdEndTime : ''
      const timeIds = time ? [time] : null
      const type = 'DATA'
      const sort = ['createdDate, desc']

      const data = {
        pageable: {
          page: this.page,
          size: this.pageSize,
          sort
        },
        reservationStartTime,
        reservationEndTime,
        createdStartTime,
        createdEndTime,
        timeIds,
        searchKey,
        type
      }
      if (this.isInvoice) {
        data.reservationInvoiceStatus = reservationInvoiceStatus || null
        data.allInvoice = (this.isInvoice && !reservationInvoiceStatus) || null
        data.channel = channel || null
        data.type = null
      }
      data.status = status === 'ALL' ? null : status

      this.$store
        .dispatch('getLifeExperienceHallsReservationAdvanced', data)
        .then(res => {
          this.originData = res.data
          this.tableData = []
          this.originData.forEach(item => {
            this.tableData.push(this.transformData(item))
          })
          this.totalNumber = res.totalNumber
          if (next) {
            next(res.data)
          }
        })
        .catch(err => {
          this.$message.error(err || '获取生命体验馆预约参观信息失败')
        })
    },
    transformData (data) {
      let dataCurrent
      const formatDateToYYYYMMDDHHMMSS = dateString => {
        const date = new Date(dateString)
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        const hours = String(date.getHours()).padStart(2, '0')
        const minutes = String(date.getMinutes()).padStart(2, '0')
        const seconds = String(date.getSeconds()).padStart(2, '0')
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
      }

      const formatDateToYYYYMMDD = dateString => {
        const date = new Date(dateString)
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        return `${year}-${month}-${day}`
      }

      const createdDate = formatDateToYYYYMMDDHHMMSS(data.createdDate)
      const date = formatDateToYYYYMMDD(data.date)

      let status = ''
      let visitors = []
      switch (data.status) {
        case 'WAITING_AUDIT':
          status = '待审核'
          break
        case 'APPROVED':
          status = data.receiveType ? `审核通过(${receiveTypeOptions[data.receiveType]})` : '审核通过'
          break
        case 'FAILED':
          status = '审核未通过'
          break
        case 'CANCEL':
          status = '已取消'
          break
        case 'CLOSE_UNPAID':
          status = '未支付关闭'
          break
        case 'USER_CANCEL':
          status = '用户已取消'
          break
        case 'WAITING_PAYMENT':
          status = '待支付'
          break
        case 'REJECT_CANCEL':
          status = '审核驳回'
          break
        case 'ADMIN_CANCEL':
          status = '管理员取消'
          break
        case 'TIME_CANCEL':
          status = '场次取消'
          break
        case 'WAITING_FINANCE_AUDIT':
          status = '财务待审核'
          break
        case 'FINANCE_PASSED':
          status = '财务审核通过'
          break
        case 'FINANCIAL_AUDIT_FAILED':
          status = '财务审核未通过'
          break
        default:
          status = '未知状态'
          break
      }
      if (data.visitors) {
        visitors = data.visitors.map((visitor, index) => {
          let identityCardType = ''
          switch (visitor.identityCardType) {
            case 'CHINESE_IDENTITY_CARD':
              identityCardType = '身份证'
              break
            case 'PASSPORT':
              identityCardType = '护照'
              break
            case 'MILITARY_ID':
              identityCardType = '军官证'
              break
            default:
              identityCardType = '其他'
          }

          return {
            ...visitor,
            identityCardTypeText: identityCardType,
            priceText: '¥' + cashCount(visitor.price, true)
          }
        })
      }
      dataCurrent = {
        ...data,
        visitors,
        date,
        createdDate,
        personCount: data.personCount,
        contactMobile: data.mobile,
        date_time: `${date} ${data.time}`,
        status: data.status,
        invoiceStatus: data.invoiceStatus,
        statusText: status
      }
      dataCurrent.invoiceStatusText = invoiceStatus[data.invoiceStatus]
      if (data.paymentDetails) {
        dataCurrent.paymentDetails = {
          ...data.paymentDetails,
          amount: '¥' + (data.paymentDetails.amount ? cashCount(data.paymentDetails.amount, true, 2) : 0),
          paymentChannel: data.paymentDetails.channel && channelFiltterOptions.find(item => item.value === data.paymentDetails.channel).label,
          time: formatDateToYYYYMMDDHHMMSS(data.paymentDetails.time)
        }
      }
      return dataCurrent
    }
  }
}
</script>
